import React, { Component } from "react";
import { connect } from "react-redux";
import { assessmentActions, userActions } from "../../../_actions";
import { CONST } from "../../../_config";
import moment from "moment";
import Dashboard from "../Dashboard/Dashboard";
import Heading from "../../AdminPanel/Component/UI/Heading";
import SearchBox from "../../AdminPanel/Component/UI/SearchBox";
import StatsCard from "../../AdminPanel/Component/UI/StatsCard";
import AddButton from "../../AdminPanel/Component/UI/AddButton";
import { TbReportAnalytics } from "react-icons/tb";
import { LuUsers, LuUserCheck } from "react-icons/lu";
import { SlReload } from "react-icons/sl";
import { MdSearch, MdArrowForwardIos, MdArrowBackIos } from "react-icons/md";
import { HiOutlineHome, HiMiniPlus } from "react-icons/hi2";
import { AiOutlineUsergroupAdd } from "react-icons/ai";
// import Heading from "../../DashboardHr/Component/UI/Heading";
// import CommonTableTeam from "../../AdminPanel/Component/UI/CommonTableTeam";
// import { LuUsers, LuUserCheck, LuDownload } from "react-icons/lu";
// import { AiOutlineFileText } from "react-icons/ai";
// import { TbUsersPlus } from "react-icons/tb";
// import { SlReload } from "react-icons/sl";
// import { FiEdit } from "react-icons/fi";
// import { RiDeleteBinLine } from "react-icons/ri";
// import { BsBarChartLine } from "react-icons/bs";
// import { LuAlarmClock } from "react-icons/lu";



class AssessmentCodes extends Component {

  constructor(props) {
    super(props);
    this.state = {
      showMsg: false,
      showMsg2: false,
      addCampaignsModal: false,
      updateUserModal: false,
      openOrderId: null,
      entries: 20,
      data: Array.from({ length: 10 }, (_, i) => ({
        id: i + 1,
        campaignname: "Campaign 1",
        launchdate: "Jan 01, 2026 10:52 AM",
        lastreminderdate: "Jany 14, 2026 10:52 AM",
        createdby: "hari@mailinator.com",
        // status: i === 2 ? "Pending" : "Completed",
      })),
      data: [
        { id: 1, userName: "Krishna", code: "KUcXQd9pUl", status: "Completed", assigned: true },
        { id: 2, userName: "Hari", code: "KUcXQd9pUl", status: "Completed", assigned: true },
        { id: 3, userName: "Taj", code: "KUcXQd9pUl", status: "Pending", assigned: false },
        { id: 4, userName: "Taj", code: "KUcXQd9pUl", status: "Pending", assigned: false },
        { id: 5, userName: "Taj", code: "KUcXQd9pUl", status: "Pending", assigned: false },
        { id: 6, userName: "Taj", code: "KUcXQd9pUl", status: "Pending", assigned: false },
        { id: 7, userName: "Taj", code: "KUcXQd9pUl", status: "Completed", assigned: true }
      ],
      pageNo: 1,
      size: 10,
      keyWord: ""
    };
    this.handleClick = this.handleClick.bind(this);

  }

  componentDidMount() {
    this.props.dispatch(assessmentActions.AllPurchasedCodes({
      "keyWord": '',
      "pageNo": 1,
      "size": this.state.size
    }));
    this.props.dispatch(assessmentActions.getOrderBookList({
      "keyWord": '',
      "pageNo": 1,
      "size": this.state.size
    }));
    this.callUserListAPI();
    window.scrollTo(0, 0);
  }

  // Handle entries dropdown change
  handleEntriesChange = (value) => {
    this.setState({ entries: value });
  };

  toggleOrder = (id) => {
    this.setState((prevState) => ({
      openOrderId: prevState.openOrderId === id ? null : id,
    }));
  };

  callUserListAPI = () => {
    const { pageNo, size, keyWord } = this.state;
    this.props.dispatch(
      assessmentActions.AllPurchasedCodes({
        pageNo,
        size,
        keyWord
      })
    );
  };

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.pageNo !== this.state.pageNo ||
      prevState.size !== this.state.size ||
      prevState.keyWord !== this.state.keyWord
    ) {
      this.callUserListAPI();
    }
  }

  handleRedirect = (path) => {
    this.props.history.push(path);
  };

  handleClick() {
    this.setState({ showMsg: true });
    setTimeout(() => {
      this.setState({ showMsg: false });
    }, 3000);
  }

  handleClick2(value) {
    this.setState({ showMsg2: true, crrCodeCopied: value });
    setTimeout(() => {
      this.setState({ showMsg2: false, crrCodeCopied: "" });
    }, 3000);
  }

  CopyClick() {
    window.alert("DJKEOPIUJH : Assessment Code Copied!!");
  }


  handleSearch = (event) => {
    event.preventDefault();
    let { value } = event.target;
    this.setState({ keyWord: value, offset: 0 });
    let data = {
      "keyWord": value,
      "pageNo": this.state.pageNo,
      "size": this.state.size
    }
    this.props.dispatch(assessmentActions.AllPurchasedCodes(data));
  }

  handleSizeChange = (e) => {
    this.setState({
      size: Number(e.target.value),
      pageNo: 1
    });
  };

  goPrev = () => {
    this.setState((prev) => ({
      pageNo: Math.max(prev.pageNo - 1, 1)
    }));
  };

  goNext = () => {
    const { AllPurchasedCodesTotal } = this.props.assessment;
    const totalPages = Math.ceil(AllPurchasedCodesTotal / this.state.size);
    this.setState((prev) => ({
      pageNo: Math.min(prev.pageNo + 1, totalPages)
    }));
  };

  render() {

    let { assessment } = this.props;
    let { AllPurchasedCodesData, AllPurchasedCodesTotal, userAssessmentUserProfileData } = assessment;

    const { addCampaignsModal, updateUserModal, entries, openOrderId, data, pageNo, size, showMsg, showMsg2, crrCodeCopied } = this.state;

    function getDetails(orderBook, field, type, orderPack) {
      if (type === 2) {
        return field &&
          orderPack &&
          orderPack["productId"] &&
          orderPack["productId"][field]
          ? orderPack["productId"][field]
          : "";
      } else if (type === 3) {
        return field && orderPack && orderPack[field] ? orderPack[field] : "";
      } else {
        return field && orderBook && orderBook[field] ? orderBook[field] : "";
      }
    }

    const start = AllPurchasedCodesTotal === 0 ? 0 : (pageNo - 1) * size + 1;
    const end = Math.min(pageNo * size, AllPurchasedCodesTotal);
    const totalPages = Math.ceil(AllPurchasedCodesTotal / size);


    console.log('AllPurchasedCodesDataAllPurchasedCodesDataAllPurchasedCodesDataAllPurchasedCodesData', AllPurchasedCodesData);

    const getPeriod = () => {
      const hour = moment().hour(); // 0–23

      if (hour >= 5 && hour < 12) return "Morning";
      if (hour >= 12 && hour < 17) return "Afternoon";
      if (hour >= 17 && hour < 21) return "Evening";
      return "Night";
    };

    let userDetails = {
      name: userAssessmentUserProfileData?.name ?? "",
      email: userAssessmentUserProfileData?.email ?? "",
      period: getPeriod()
    };

    let { loading } = assessment;
    return (
      <Dashboard userDetails={userDetails} logout={this.logout} switchToSelf={this.switchToSelf} loading={loading}>
        <div className="space-y-6 p-8">
          {/* Header Row */}
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <Heading className="text-lg" title="Setting" />
              {/* <h2 className="text-lg font-semibold">My Campaigns</h2> */}
              {/* <div className="h-6 w-[1px] bg-gray-300" />
              <span className="text-sm textblack flex items-center gap-2">
                <span className="textblack"><HiOutlineHome size={22} /></span>
                <span className="textblack"><MdArrowForwardIos size={16} /></span>
                <span className="textblack">My Campaigns List</span>
              </span> */}
            </div>

            {/* <div className="flex items-center gap-3">
              <AddButton title="Add New" Icon={HiMiniPlus} className="bgcolor text-white" onClick={this.openAddCampaignsModal} />
            </div> */}
          </div>



          {/* Tabs */}
          {/* <div className="border-b border-gray-200 mb-6">
            <nav className="flex space-x-8">
              <button onClick={() => this.handleRedirect('/assessment/settings')} className="pb-3 text-sm font-medium textlight hover:text-gray-700">
                Billing History
              </button>
              <button onClick={() => this.handleRedirect('/assessment/assessment-codes')} className="pb-3 text-sm font-semibold border-b-2 border-black text-black">
                Assessment Codes
              </button>
            </nav>
          </div> */}

          {/* <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
            <StatsCard icon={LuUsers} label="Total" value="2" />
            <StatsCard icon={LuUserCheck} label="Clicked" value="27" />
            <StatsCard icon={SlReload} label="Completed" value="27" />
            <StatsCard icon={SlReload} label="Not Completed" value="27" />
          </div> */}


          {showMsg && (
            <div className="fixed whitespace-nowrap z-20 top-24 right-0 p-6 py-4 rounded-l-lg shadow-md border-l-4 border-green-500 text-[#3D405B] bg-white ">
              <p> Assessment Survey Link Copied !</p>
            </div>
          )}
          {showMsg2 && (
            <div className="fixed whitespace-nowrap z-20 top-24 right-0 p-6 py-4 rounded-l-lg shadow-md border-l-4 border-green-500 text-[#3D405B] bg-white ">
              <p> Assessment Code Copied !</p>
              <h2 className="text-lg font-medium">{crrCodeCopied}</h2>
            </div>
          )}

          <div className="w-full p-6 space-y-4 bg-gray-100 border rounded">
            <h1>Assessment Survey Link:</h1>
            <div className="border bg-white w-full flex justify-between rounded text-[#3D405B] items-center ">
              <p className="px-4 truncate ">
                {CONST.SURVEY_ASSESSMENT}
              </p>
              <div className="flex items-center">
                <button
                  onClick={() => {
                    this.handleClick();
                    navigator.clipboard.writeText(CONST.SURVEY_ASSESSMENT)
                  }}
                  className="p-2 px-2 border-l
                                  hover:text-[#4CAF50] cursor-pointer hover:bg-[#4CAF50]/10 transition-all duration-100
                                  ">
                  <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-copy" width="24" height="24" viewBox="0 0 24 24" strokeWidth="1.5" stroke="#2c3e50" fill="none" strokeLinecap="round" strokeLinejoin="round">  {" "}  <path stroke="none" d="M0 0h24v24H0z" fill="none" />{" "}  <rect x="8" y="8" width="12" height="12" rx="2" />{" "}  <path d="M16 8v-2a2 2 0 0 0 -2 -2h-8a2 2 0 0 0 -2 2v8a2 2 0 0 0 2 2h2" /></svg>
                </button>
                <a
                  href={CONST.SURVEY_ASSESSMENT}
                  target="blank" className="p-2 px-2 border-l hover:text-[#4CAF50] cursor-pointer hover:bg-[#4CAF50]/10 transition-all duration-100">
                  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none">
                    <path d="M10 4H6C5.46957 4 4.96086 4.21071 4.58579 4.58579C4.21071 4.96086 4 5.46957 4 6V18C4 18.5304 4.21071 19.0391 4.58579 19.4142C4.96086 19.7893 5.46957 20 6 20H18C18.5304 20 19.0391 19.7893 19.4142 19.4142C19.7893 19.0391 20 18.5304 20 18V14M12 12L20 4M20 4V9M20 4H15" stroke="#2c3e50" strokeOpacity="1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </a>
              </div>
            </div>
          </div>

          {/* Controls */}
          <div className="flex justify-between items-center mb-4">
            <div className="flex items-center gap-2 text-sm textblack">
              Show
              <select value={this.state.size} onChange={this.handleSizeChange} className="border rounded-md px-2 py-1">
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={50}>50</option>
              </select>
              entries
            </div>

            <div className="flex items-center gap-3 text-sm textblack">
              <div className="">
                <SearchBox
                  value={this.state.keyWord}
                  onChange={this.handleSearch}
                  placeholder="Search"
                />
              </div>
              <div>{start}-{end} of {AllPurchasedCodesTotal}</div>
              <div onClick={this.goPrev} disabled={this.state.pageNo === 1} className={`p-2 rounded-md ${this.state.pageNo === 1 ? "opacity-40 cursor-not-allowed" : "bglightcolor textcolor"}`}>
                <MdArrowBackIos size={20} />
              </div>
              <div onClick={this.goNext} disabled={this.state.pageNo === totalPages} className={`p-2 rounded-md ${this.state.pageNo === totalPages ? "opacity-40 cursor-not-allowed" : "bglightcolor textcolor"}`}>
                <MdArrowForwardIos size={20} />
              </div>
            </div>
          </div>

          <div className="overflow-x-auto">
            <table className="min-w-full bg-white border-collapse">
              {/* Table Header */}
              <thead>
                <tr className="bg-slate-50 text-slate-600 text-sm leading-normal">
                  <th className="py-4 px-6 text-left font-medium">S.No.</th>
                  <th className="py-4 px-6 text-left font-medium">User Name</th>
                  <th className="py-4 px-6 text-left font-medium">Product Name</th>
                  <th className="py-4 px-6 text-left font-medium">Assessment Code</th>
                  <th className="py-4 px-6 text-center font-medium">Status</th>
                  <th className="py-4 px-6 text-left font-medium">Date</th>
                  {/* <th className="py-4 px-6 text-center font-medium">Assigned</th> */}
                  <th className="py-4 px-6 text-center font-medium">Reports</th>
                </tr>
              </thead>

              {/* Table Body */}
              <tbody className="text-gray-700 text-sm">
                {AllPurchasedCodesData &&
                  AllPurchasedCodesData.length > 0
                  ? AllPurchasedCodesData.map((element, index) => (
                    <>
                      <tr key={index} className="border-b border-slate-100 transition-colors">
                        <td className="py-4 px-6 text-left">{index + 1}</td>
                        <td className="py-4 px-6 text-left font-medium">{element.name}</td>
                        <td className="py-4 px-6 text-left font-medium">{element?.productId?.name ?? "NA"}</td>
                        <td className="py-4 px-6 text-left">
                          <div className="flex items-center space-x-4">
                            <span className="border-[1.8px] w-36 text-center rounded border-spacing-4 border-separate border-dashed p-2 px-6 bg-[#1976D2]/10 text-[#1976D2]  border-[#1976D2]">{element.otpCode}</span>
                            <span onClick={() => { this.handleClick2(element.otpCode); navigator.clipboard.writeText(element.otpCode) }} className="border  text-[#212121]/70 hover:text-[#1976D2] p-1.5 rounded cursor-pointer hover:bg-[#1976D2]/10 transition-all duration-100 ">
                              <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-device-floppy " width="24" height="24" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path stroke="none" d="M0 0h24v24H0z" fill="none" /><rect x="8" y="8" width="12" height="12" rx="2" /><path d="M16 8v-2a2 2 0 0 0 -2 -2h-8a2 2 0 0 0 -2 2v8a2 2 0 0 0 2 2h2" /></svg>
                            </span>
                          </div>
                        </td>
                        <td className="py-4 px-6 text-center">
                          {element && element.isComplete ?
                            <span className="px-6 py-2 bg-[#E3F2FD] textcolor text-sm rounded w-36">Completed</span>
                            :
                            <span className="px-6 py-2 border border-[#1976D2] textcolor text-sm rounded w-36">Pending</span>
                          }
                        </td>
                        <td className="py-4 px-6 text-left font-medium">{element?.productId?.createdAt ? moment(parseInt(element.productId.createdAt)).utcOffset("+05:30").format("DD MMM YYYY, hh:mm A") : "NA"
                        }</td>
                        {/* <td className="py-4 px-6 text-center">
                          <span className={`font-semibold ${element.assigned ? 'text-blue-600' : 'text-red-500'}`}>
                            {element.assigned ? 'Yes' : 'No'}
                          </span>
                        </td> */}
                        <td className="flex items-center justify-center py-4 px-6 text-center">
                          {element && element.isReport ?
                            <div className="flex items-center justify-center border textblack hover:text-[#1976D2] p-1.5 rounded cursor-pointer hover:border-[#1976D2] transition-all duration-100 w-10 h-10">
                              <TbReportAnalytics size={28} />
                            </div>
                            :
                            <div className="flex items-center justify-center border cursor-not-allowed textlight hover:text-[#1976D2] p-1.5 rounded hover:border-[#1976D2] transition-all duration-100 w-10 h-10">
                              <TbReportAnalytics size={28} />
                            </div>
                          }
                        </td>
                      </tr>
                    </>
                  )) : null}
              </tbody >
            </table>
          </div>

        </div>


      </Dashboard >
    );
  }
}

function mapStateToProps(state) {
  //console.log("state  ", state);
  const { loggingIn } = state.authentication;
  const { questions, user, assessment } = state;
  return {
    loggingIn,
    questions,
    user,
    assessment,
  };
}

export default connect(mapStateToProps)(AssessmentCodes);

